import React, { useState } from 'react'

const TabButton = ({
  tabIndex,
  label,
  selectedTab,
  handleTabClick,
  fromSubs,
  tourId,
  children
}) => {
  return (
    <div>
      <button
        className={`block text-center rounded-lg  md:px-24 py-5 duration-100 transition-all relative y-5 px-20 min-w-[160px] tab
          ${fromSubs ? 'border border-1 border-purple-500' : 'border-0 '}
          ${
            selectedTab === tabIndex
              ? 'bg-purple-500 text-white'
              : 'bg-white text-body'
          }`}
        onClick={() => handleTabClick(tabIndex)}
        label={label}
        data-tour={tourId || undefined}
      >
        {label}
      </button>
    </div>
  )
}

const PillTabs = ({ tabs, startTab, fromPlay, withSlider, fromSubs }) => {
  const [selectedTab, setSelectedTab] = useState(startTab ? startTab : 1)

  const handleTabClick = (tabIndex) => {
    setSelectedTab(tabIndex)
    tabs[tabIndex - 1].onClick && tabs[tabIndex - 1].onClick()
  }

  return (
    <div className={`${fromPlay ? 'w-full' : 'mb-30'}`}>
      <div className={`flex ${fromPlay ? 'mb-10' : withSlider ? '' : 'mb-30'}`}>
        <div
          className={`tabs flex border-body-alt p-5 rounded-lg gap-5 ${
            fromPlay
              ? 'justify-center w-full'
              : fromSubs
              ? '-mt-20'
              : 'border border-1 '
          } ${withSlider ? 'md:-mb-20 ' : ''}`}
        >
          {tabs.map((tab, index) => (
            <TabButton
              key={index}
              tabIndex={index + 1}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
              label={tab.title}
              fromSubs={fromSubs}
              tourId={tab.tourId}
            />
          ))}
        </div>
      </div>
      <div className={`tab-content ${fromPlay ? 'w-full' : ''}`}>
        {tabs.map((tab, index) =>
          selectedTab === index + 1 ? (
            <div key={index}>{tab.content}</div>
          ) : null
        )}
      </div>
    </div>
  )
}

export default PillTabs
